import { render, staticRenderFns } from "./TabItem.vue?vue&type=template&id=1aa5ad85"
import script from "./TabItem.vue?vue&type=script&lang=ts"
export * from "./TabItem.vue?vue&type=script&lang=ts"
import style0 from "./TabItem.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Headline: require('/app/components/base/Headline/Headline.vue').default,ImageComponent: require('/app/components/base/ImageComponent/ImageComponent.vue').default,LinkComponent: require('/app/components/base/LinkComponent/LinkComponent.vue').default})
